import { Smartphone } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/ui/select';

export type InstalledFilter = '' | 'installed' | 'not_installed';

const ALL_VALUE = '__all__';

interface InstalledFilterSelectProps {
  value: InstalledFilter;
  onChange: (value: InstalledFilter) => void;
  className?: string;
}

export function InstalledFilterSelect({ value, onChange, className }: InstalledFilterSelectProps) {
  return (
    <Select
      value={value || ALL_VALUE}
      onValueChange={(v) => onChange(v === ALL_VALUE ? '' : (v as InstalledFilter))}
    >
      <SelectTrigger className={cn('w-auto gap-1.5 pr-3', className)}>
        <Smartphone className="size-3.5 shrink-0 text-muted-foreground" />
        <SelectValue placeholder="Instalação" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL_VALUE}>Todos</SelectItem>
        <SelectItem value="installed">Instalados</SelectItem>
        <SelectItem value="not_installed">Não instalados</SelectItem>
      </SelectContent>
    </Select>
  );
}
